import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

export interface BreadcrumbItem {
  label: string;
  routerLink?: (string | number)[];
  queryParams?: Record<string, unknown>;
}

@Component({
  selector: 'app-breadcrumb',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  template: `
    <nav class="flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400 mb-4">
      @for (item of items(); track $index; let last = $last) {
        @if (!last) {
          <a [routerLink]="item.routerLink" [queryParams]="item.queryParams" class="hover:text-gray-800 dark:hover:text-gray-200">{{ item.label }}</a>
          <span>/</span>
        } @else {
          <span class="text-gray-800 dark:text-gray-100">{{ item.label }}</span>
        }
      }
    </nav>
  `,
})
export class BreadcrumbComponent {
  readonly items = input.required<BreadcrumbItem[]>();
}
